<template>
  <div v-if="loadingDataAirline" class="template-config">
    <!--Background color of header-->
    <v-style v-if="airline.template_config.mb_header_bg_color != '' && airline.template_config.mb_header_bg_color != '#'">
      div.logo, .hd-header-background-color { background-color: {{ airline.template_config.mb_header_bg_color }}; }
    </v-style>
    <!--Text color of header-->
    <v-style v-if="airline.template_config.mb_header_text_color != '' && airline.template_config.mb_header_text_color != '#'">
      div.footer, div.language-option, .hd-header-color{ color: {{ airline.template_config.mb_header_text_color }}; }
    </v-style>
    <!--Background color of footer-->
    <v-style v-if="airline.template_config.mb_footer_bg_color != '' && airline.template_config.mb_footer_bg_color != '#'">
      div.footer, .ws-footer { background-color: {{ airline.template_config.mb_footer_bg_color }}; }
    </v-style>
    <!--Text color of footer-->
    <v-style v-if="airline.template_config.mb_footer_text_color != '' && airline.template_config.mb_footer_text_color != '#'">
      div.footer, .ws-footer{ color: {{ airline.template_config.mb_footer_text_color }}; }
    </v-style>
    <!--Font size of footer-->
    <v-style v-if="airline.template_config.mb_footer_text_size != ''">
      div.footer{ font-size: {{ airline.template_config.mb_footer_text_size }}px; }
    </v-style>
    <!--Text color of heading 2-->
    <v-style v-if="airline.template_config.mb_h2_text_color != '' && airline.template_config.mb_h2_text_color != '#'">
      h2,h2.title,.item-title,h3,.block-item h3.title, .ws-title{ color: {{ airline.template_config.mb_h2_text_color }}; }
    </v-style>
    <!--Text color of body-->
    <v-style v-if="airline.template_config.mb_body_text_color != '' && airline.template_config.mb_body_text_color != '#'">
      body{ color: {{ airline.template_config.mb_body_text_color }}; }
    </v-style>
    <!--Text color of heading 1-->
    <v-style v-if="airline.template_config.mb_h1_text_color != '' && airline.template_config.mb_h1_text_color != '#'">
      h1, .ws-nav__inner .hd-nav-title-color{ color: {{ airline.template_config.mb_h1_text_color }}; }
    </v-style>
    <!--Background color of heading 1-->
    <v-style v-if="airline.template_config.mb_h1_bg_color != '' && airline.template_config.mb_h1_bg_color != '#'">
      div.page-title-link,.block-item,.messages_list .block-item.bgRead0, .hd-nav-title-background-color{ background-color:
      {{ airline.template_config.mb_h1_bg_color }}; }
    </v-style>
    <!--Background color of download button-->
    <v-style
      v-if="airline.template_config.mb_download_btn_bg_color != '' && airline.template_config.mb_download_btn_bg_color != '#'"
    >
      .download-button, .hd-download-btn-background-color{ background-color:
      {{ airline.template_config.mb_download_btn_bg_color }}; }
    </v-style>
    <!--Color of text detail download button-->
    <v-style
      v-if="airline.template_config.mb_download_btn_text_color != '' && airline.template_config.mb_download_btn_text_color != '#'"
    >
      .hd-download-btn-color, .download-button>span{ color: {{ airline.template_config.mb_download_btn_text_color }}; }
    </v-style>
    <!--Background color of body-->
    <v-style v-if="airline.template_config.mb_body_bg_color != '' && airline.template_config.mb_body_bg_color != '#'">
      body{ background-color: {{ airline.template_config.mb_body_bg_color }}; }
    </v-style>
    <!--Background color of normal button-->
    <v-style v-if="airline.template_config.mb_normal_btn_bg_color != '' && airline.template_config.mb_normal_btn_bg_color != '#'">
      .btn-detail,.hotel-list .btn-detail,.btnDefault,a.btnDefault, button.btnDefault, .hd-normal-btn-background-color{
      background-color: {{ airline.template_config.mb_normal_btn_bg_color }}; }
    </v-style>
    <!--Text color of normal button-->
    <v-style
      v-if="airline.template_config.mb_normal_btn_text_color != '' && airline.template_config.mb_normal_btn_text_color != '#'"
    >
      .btn-detail,.hotel-list .btn-detail,.btnDefault,a.btnDefault, button.btnDefault, .hd-normal-btn-color{ border-color:
      {{ airline.template_config.mb_normal_btn_text_color }}; color: {{ airline.template_config.mb_normal_btn_text_color }}; }
    </v-style>
    <!--Background color of select button-->
    <v-style v-if="airline.template_config.mb_select_btn_bg_color != '' && airline.template_config.mb_select_btn_bg_color != '#'">
      .btn-select, .hotel-list .btn-select, .hd-service-background-color { background-color:
      {{ airline.template_config.mb_select_btn_bg_color }}; border-color: {{ airline.template_config.mb_select_btn_bg_color }}; }
    </v-style>
    <!--Text color of select button-->
    <v-style
      v-if="airline.template_config.mb_select_btn_text_color != '' && airline.template_config.mb_select_btn_text_color != '#'"
    >
      .btn-select, .hotel-list .btn-select, .btn-select .item-title, .btn-select .bullet_right, .hd-item-title-color { color:
      {{ airline.template_config.mb_select_btn_text_color }}; }
    </v-style>
    <!--Font size of title-->
    <v-style v-if="airline.template_config.mb_title_text_size != '' && airline.template_config.mb_title_text_size != '#'">
      .fontsize-title { font-size: {{ airline.template_config.mb_title_text_size }}px !important; }
    </v-style>
    <!--Mobile Logo on creditcard-->
    <v-style
      v-if="airline.template_config.logo_creditcard_mobile != null && airline.template_config.logo_creditcard_mobile != ''"
    >
      .virtual-card-wrap .front-card .section-top .logo-card{ background: url({{
        airline.template_config.logo_creditcard_mobile
      }}); background-repeat: no-repeat; background-size: auto 100%; }
    </v-style>
    <!--logo header mobile-->
    <v-style v-if="airline.template_config.logo_header_mobile != null && airline.template_config.logo_header_mobile != ''">
      .header-wrapper .image-logo{ background: url({{ airline.template_config.logo_header_mobile }}); background-repeat:
      no-repeat; background-size: contain; height: inherit; }
    </v-style>

    <!--List for Icon-->
    <!--Icon of message-->
    <v-style v-if="airline.template_config.logo_iconofmessage != null && airline.template_config.logo_iconofmessage != ''">
      .sb_message{ background: url({{ airline.template_config.logo_iconofmessage }}) no-repeat; background-position-y: unset;
      background-size: auto 100%; }
    </v-style>
    <!--Mobile Logo on Flight-->
    <v-style v-if="airline.template_config.logo_flighttakeoff != null && airline.template_config.logo_flighttakeoff != ''">
      .sb_flight_takeoff{ background: url({{ airline.template_config.logo_flighttakeoff }}) no-repeat; background-position-y:
      unset; background-size: auto 100%; }
    </v-style>
    <!--Mobile Logo on Hotel Service-->
    <v-style v-if="airline.template_config.logo_hotelservice != null && airline.template_config.logo_hotelservice != ''">
      .sb_hotel{ background: url({{ airline.template_config.logo_hotelservice }}) no-repeat; background-position-y: unset;
      background-size: auto 100%; }
    </v-style>
    <!--Mobile Logo on Mean plan Service-->
    <v-style v-if="airline.template_config.logo_meanplanservice != null && airline.template_config.logo_meanplanservice != ''">
      .sb_refreshment{ background: url({{ airline.template_config.logo_meanplanservice }}) no-repeat; background-position-y:
      unset; background-size: auto 100%; }
    </v-style>
    <!--Mobile Logo on Taxi Service-->
    <v-style v-if="airline.template_config.logo_taxiservice != null && airline.template_config.logo_taxiservice != ''">
      .sb_taxi{ background: url({{ airline.template_config.logo_taxiservice }}) no-repeat; background-position-y: unset;
      background-size: auto 100%; }
    </v-style>
    <!--Mobile Logo on Train Service-->
    <v-style v-if="airline.template_config.logo_trainservice != null && airline.template_config.logo_trainservice != ''">
      .sb_train{ background: url({{ airline.template_config.logo_trainservice }}) no-repeat; background-position-y: unset;
      background-size: auto 100%; }
    </v-style>
    <!--Mobile Logo on Rental Car Service-->
    <v-style v-if="airline.template_config.logo_rentalservice != null && airline.template_config.logo_rentalservice != ''">
      .sb_car{ background: url({{ airline.template_config.logo_rentalservice }}) no-repeat; background-position-y: unset;
      background-size: auto 100%; }
    </v-style>
    <!--Mobile Logo on Bus Service-->
    <v-style v-if="airline.template_config.logo_busservice != null && airline.template_config.logo_busservice != ''">
      .sb_bus{ background: url({{ airline.template_config.logo_busservice }}) no-repeat; background-position-y: unset;
      background-size: auto 100%; }
    </v-style>
    <!--Mobile Logo on hotel voucher-->
    <v-style v-if="airline.template_config.logo_coupon != null && airline.template_config.logo_coupon != ''">
      .sb_coupon{ background: url({{ airline.template_config.logo_coupon }}) no-repeat; background-position-y: unset;
      background-size: auto 100%; }
    </v-style>
    <!--Mobile font size header-->
    <v-style>
      .header-fontsize, hd-header-fontsize { font-size:
      {{ airline.template_config.mb_header_text_size ? airline.template_config.mb_header_text_size : 14 }}px; }
    </v-style>
    <!--Mobile font size button-->
    <v-style>
      .btn-detail,.hotel-list .btn-detail,.btnDefault,a.btnDefault, button.btnDefault, .btn-select,.hotel-list .btn-select,
      .btnSave, .btn-select a, .ws-btn { font-size:
      {{ airline.template_config.mb_button_text_size ? airline.template_config.mb_button_text_size : 14 }}px; }
    </v-style>
    <!--Mobile font size body-->
    <v-style>
      body { font-size: {{ airline.template_config.mb_body_text_size ? airline.template_config.mb_body_text_size : 14 }}px; }
    </v-style>
    <!--Button shuttle bus -->
    <v-style v-if="airline.template_config.mb_bg_btn_shuttle_bus && airline.template_config.mb_text_btn_shuttle_bus">
      .bg-btn-shuttle-bus { background-color: {{ airline.template_config.mb_bg_btn_shuttle_bus }} !important; }
      .color-btn-shuttle-bus { color: {{ airline.template_config.mb_text_btn_shuttle_bus }} !important; }
    </v-style>
    <v-style v-if="airline.template_config.mb_text_status_new_flight">
      .status-new-flight { color: {{ airline.template_config.mb_text_status_new_flight }} !important; }
    </v-style>
    <v-style>
      .wrap-voucher { background-color: {{ airline.template_config.billing_infomation_background_color || '#FFDE73' }} !important;
      border-color: {{ airline.template_config.billing_infomation_border_color || '#FFB700' }} !important; }
    </v-style>
    <v-style>
      .how-does-it-work-icon-color { color: {{ airline.template_config.mb_icon_color || '#7fbaf7' }} !important; }
    </v-style>
  </div>
</template>

<script>
export default {
  name: 'TemplateConfig',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    loadingDataAirline: function () {
      return this.loading
    }
  },
  watch: {
    airline: function () {
      this.loading = true
    }
  }
}
</script>
